// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1ZgMl","emails":"CreateEditClinics_emails__zQrbo","emailTagLabel":"CreateEditClinics_emailTagLabel__1KXMX"};